import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-monoalphabetic',
  templateUrl: './monoalphabetic.component.html',
  styleUrls: ['../topic-style.css', './monoalphabetic.component.css']
})
export class MonoalphabeticComponent extends CryptoView {

  _key: string;

  @Input()
  set key(value: string) {
    this._key = value;
    if (this._key && this.modus == "defineKey") {
      console.log(value);
      this.setmapping(value);
    }
  }

  get key(): string {
    return this._key;
  }
  @Input() current: string;
  private _modus: string
  @Input()
  set modus(value: string) {
    this._modus = value;
    if (this._key && value == "defineKey") {
      this.setmapping(this.key);
    }
  }
  get modus(){
    return this._modus;
  }
  @Input() direction: string;
  @Output() studentKey = new EventEmitter<string>();

  inputs: string[];
  hints: string[] = [];

  constructor(topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = new Array(26).fill(" ");
  }

  /** used by the html to highlight the correct element */
  currentIndex(): number {
    if(!this.current){
      return -1;
    }
    if (this.modus == "highlight") {
      return this.current.charCodeAt(0) - 65;
    } else if (this.modus == "withoutKey") {
      return this.current.charCodeAt(0) - 65;
    } else {
      return -1;
    }
  }

  /** returns the student mapping */
  getMapping() {
    return this.inputs.join("").slice(0, 26);
  }

  /** sets the mapping */
  setmapping(mapping: string) {
    let tempMapping = mapping.slice(0, 26).split("");
    for(let i of this.createArray(26)){

      if(this.hints[i] != undefined){
        this.inputs[i] = this.hints[i];
      } else {
        this.inputs[i] = tempMapping[i];
      }
    }
    this.studentKey.emit(this.getMapping());
  }

  /** resets the mapping */
  resetmapping() {
    this.setmapping("                               ")
  }

  /** sets the hints */
  setHints(hints: string[]) {
    this.hints = hints;
    for(let hint in hints){
      this.inputs[hint] = hints[hint];
    }
  }

  /** emits the key */
  normalizeKey() {
    this.studentKey.emit(this.key);
  }

  /** fills the mapping */
  fillMapping() {
    for (let i of this.createArray(26)) {
      this.inputs[i] = this.key.charAt(i);
    }
  }

  /** normalizes and emits the key on change */
  changeInput(i: number) {
    this.inputs[i] = (' ').concat(this.cryptoService.normalizeText(this.inputs[i]).trim()).slice(-1);
    this.studentKey.emit(this.getMapping());
  }
}
